import React from "react";
import img2 from "../Assets/bg2.jpg";
import { Link } from "react-router-dom";
import bg1 from "../Assets/projects/bg1.JPG";
import bg2 from "../Assets/projects/bg2.jpg";
import bg3 from "../Assets/projects/bg3.JPG";
import bg4 from "../Assets/projects/bg4.JPG";

const Projects = () => {
  return (
    <div className='my-8 md:my-14 lg:my-20 lg:container mx-auto px-4'>
      <h1 className=' text-4xl text-left font-extrabold py-8'>
        <span className='border-b-4 border-b-green-600'>PRO</span>JECTS
      </h1>
      <div className='overflow-x-auto'>
        <div className='grid grid-cols-1 slg:grid-cols-3 xl:grid-cols-4 gap-4  w-full overflow-x-scroll  mx-auto items-center'>
          {/* Project 1 */}
          <div className='hover:scale-95 transition duration-1000 '>
            <img
              src={bg1}
              alt=''
              className='h-[20rem] slg:h-[25rem] object-cover w-full'
            />
          </div>
          <div className=' hover:scale-95 transition duration-1000'>
            <img
              src={bg2}
              alt=''
              className='h-[20rem] slg:h-[25rem] object-cover w-full '
            />
          </div>
          <div className=' hover:scale-95 transition duration-1000'>
            <img
              src={bg3}
              alt=''
              className='h-[20rem] slg:h-[25rem] object-cover w-full'
            />
          </div>
          <div className='relative hover:scale-95 transition duration-1000 '>
            <Link to={`/projects`}>
              <img
                src={bg4}
                alt=''
                className='h-[20rem] slg:h-[25rem] object-cover w-full '
              />

              <div className='absolute top-0 bg-black bg-opacity-75 w-full h-full'>
                <div className='flex items-center justify-center h-full '>
                  <h1 className='text-white font-bold border-b-2 border-green-600'>
                    VIEW MORE
                  </h1>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
